import React from 'react';
import { Carousel } from 'antd';

interface PropertyImage {
  imageUrl: string;
  fileName?: string;
}

interface PropertyImagesSectionProps {
  images: PropertyImage[];
  isLoading: boolean;
}

export const PropertyImagesSection: React.FC<PropertyImagesSectionProps> = ({
  images,
  isLoading,
}) => {
  if (isLoading || images.length === 0) return null;

  return (
    <div className="bg-white rounded-lg p-6">
      <h3 className="text-lg text-left font-semibold text-gray-900 mb-4">
        Property Images ({images.length})
      </h3>

      {images.length === 1 ? (
        <div className="flex justify-center">
          <img
            src={images[0]?.imageUrl}
            alt="Property with window locations"
            className="max-w-full h-auto rounded-lg border border-gray-200"
            style={{ maxHeight: '350px' }}
          />
        </div>
      ) : (
        <div className="relative">
          <Carousel
            autoplay
            autoplaySpeed={3000}
            arrows
            className="property-images-carousel [&_.slick-arrow]:text-primary-500"
          >
            {images.map((image, index) => (
              <div key={index}>
                <div className="flex justify-center items-center" style={{ minHeight: '300px' }}>
                  <img
                    src={image.imageUrl}
                    alt={`Property image ${index + 1}`}
                    className="max-w-full h-auto rounded-lg border border-gray-200"
                    style={{ maxHeight: '350px', margin: '0 auto' }}
                  />
                </div>
              </div>
            ))}
          </Carousel>
        </div>
      )}
    </div>
  );
};
